import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { actionSet } from './utils'
import { showSpinner, hideSpinner } from 'action/spinner'
import { getPages } from 'component/pagination/utils'

import {
  FETCH_EXCLUSION_SUBTYPE_REQUEST,
  FETCH_EXCLUSION_SUBTYPE_SUCCESS,
  FETCH_EXCLUSION_SUBTYPE_ERROR,
  SAVE_EXCLUSION_SUBTYPE_REQUEST,
  SAVE_EXCLUSION_SUBTYPE_SUCCESS,
  SAVE_EXCLUSION_SUBTYPE_ERROR,
  REMOVE_EXCLUSION_SUBTYPE_REQUEST,
  REMOVE_EXCLUSION_SUBTYPE_SUCCESS,
  REMOVE_EXCLUSION_SUBTYPE_ERROR,
} from 'actionTypes'

export const fetchExclusionSubtype =
  (token, filters, callback) => async (dispatch) => {
    try {
      dispatch(showSpinner())
      dispatch(actionSet(FETCH_EXCLUSION_SUBTYPE_REQUEST))

      const response = await new Api(token, dispatch).post(
        `${API_URL.FETCH_EXCLUSION_SUBTYPE}?page=${filters.page}&size=${filters.size}`,
        filters
      )
      dispatch(getPages(response.data.pages))

      return dispatch(
        actionSet(FETCH_EXCLUSION_SUBTYPE_SUCCESS, response.data.resultList)
      )
    } catch (error) {
      return dispatch(actionSet(FETCH_EXCLUSION_SUBTYPE_ERROR, error))
    } finally {
      callback && callback()
      dispatch(hideSpinner())
    }
  }

export const saveExclusionSubtype =
  (token, data, success = null) =>
  async (dispatch) => {
    try {
      dispatch(showSpinner())
      dispatch(actionSet(SAVE_EXCLUSION_SUBTYPE_REQUEST))

      const response = await new Api(token, dispatch).post(
        `${API_URL.SAVE_EXCLUSION_SUBTYPE}`,
        data
      )

      success && success(response.data, 'save')
      return dispatch(actionSet(SAVE_EXCLUSION_SUBTYPE_SUCCESS, response.data))
    } catch (error) {
      return dispatch(actionSet(SAVE_EXCLUSION_SUBTYPE_ERROR, error))
    } finally {
      dispatch(hideSpinner())
    }
  }

export const removeExclusionSubtype =
  (token, data, success) => async (dispatch) => {
    try {
      dispatch(showSpinner())
      dispatch(actionSet(REMOVE_EXCLUSION_SUBTYPE_REQUEST))

      const response = await new Api(token, dispatch).post(
        `${API_URL.REMOVE_EXCLUSION_SUBTYPE}`,
        data
      )

      success && success(response.data, 'remove')
      return dispatch(
        actionSet(REMOVE_EXCLUSION_SUBTYPE_SUCCESS, response.data)
      )
    } catch (error) {
      return dispatch(actionSet(REMOVE_EXCLUSION_SUBTYPE_ERROR, error))
    } finally {
      dispatch(hideSpinner())
    }
  }
